



























import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import { sanitizeLinkUrl } from '@shared/helpers/sanitizeLinkUrl';
import { SBCustomCallToAction } from '@shared/types/storyblok';
import { BaseHeading } from '@shared/ui';

import Container from '~/components/Container.vue';
import PromotionCard from '~/components/PromotionCard/PromotionCard.vue';

interface CallToAction {
  label: string;
  link: string;
  backgroundColor?: string;
  textColor?: string;
}
const fromSBCustomCTA = (cta: SBCustomCallToAction): CallToAction => ({
  label: cta.label,
  link: sanitizeLinkUrl(cta.link.cached_url),
  backgroundColor: cta.background_color?.color,
  textColor: cta.text_color?.color,
});

export default defineComponent({
  name: 'PromotionsGrid',
  components: {
    Container,
    PromotionCard,
    BaseHeading,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    promotions: {
      type: Array,
      default: () => [],
    },
    // eslint-disable-next-line vue/prop-name-casing
    call_to_action: {
      type: Array as PropType<SBCustomCallToAction[]>,
      default: () => [],
    },
  },
  setup(props) {
    const callToAction = computed(() => props.call_to_action.map(fromSBCustomCTA)[0] ?? null);
    return {
      callToAction,
    };
  },
});
